// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_f3-0";
export var fulfillmentPanelBody = "_f3-1";